import { useMutation } from '@tanstack/react-query';

import { Agents } from '@air/api';
import { callAirApi } from '@air/utils-api';

export type UsePrivateWorkspaceAgentSessionCancelMutationParams = NonNullable<
  Parameters<typeof Agents.Sessions.cancel>[0]
>;

export const usePrivateWorkspaceAgentSessionCancelMutation = () =>
  useMutation({
    mutationFn: async (params: UsePrivateWorkspaceAgentSessionCancelMutationParams) =>
      callAirApi(() => Agents.Sessions.cancel(params)),
  });
